import { createStore } from '../_core/createStore';
import { lazyDependency } from '../_core/lazyDependency';
import { pickState } from '../_core/pickState';
import { Store } from '../_core/types/Store';
import useUserStore from '../userStore/useUserStore';
import { keysToPersist, parameterStore } from './parameterStore';
import { ParameterState } from './types/ParameterState';

const useParameterStore: Store<ParameterState> = createStore<ParameterState>({
  creator: parameterStore,
  id: 'parameter',
  middlewares: {
    devtools: true,
    persist: {
      partialize(state) {
        const userStore = lazyDependency(() => useUserStore);

        // current user is available. only keep keys that are required when authenticated.
        if (userStore.getState().computed.hasCurrentUser) {
          return {
            hasDuplicateApplication: state.hasDuplicateApplication,
            leadChannelCode: state.leadChannelCode,
            migrateUser: state.migrateUser,
            token: state.token,
            vehicleId: state.vehicleId,
          } as ParameterState;
        }

        return pickState(state, keysToPersist);
      },
    },
  },
});

export default useParameterStore;
